import { Stack } from '@genial/components';
import React from 'react';

import { CustomerEndOfList } from '../CustomerEndOfList';
import { CustomerListLoadingMemoized } from '../CustomerListLoading';

export interface ListBottomProps {
  dataLength: number;
  hasNextPage: boolean;
  isLoading: boolean;
  isLoadingMore: boolean;
}

export const CustomerListBottom: React.FC<ListBottomProps> = ({
  dataLength,
  hasNextPage,
  isLoading,
  isLoadingMore,
}) => {
  const hasData = dataLength > 0;

  if (!isLoading && !isLoadingMore && !!hasData && !hasNextPage && dataLength > 20) {
    return <CustomerEndOfList />;
  }

  if (hasData && !!isLoadingMore) {
    return (
      <Stack pt="stack.nano">
        <CustomerListLoadingMemoized />
      </Stack>
    );
  }

  return null;
};
